import React from 'react';
import moment from 'moment/moment';

import { trans } from '../../../../localization';
import { EnumOrderMerchantStatus } from '../../../../constants/enum';
import { COMMON_CONST } from '../../../../constants/constants';

export default class MAssignedCountDownTime extends React.Component {
  state = {
    isTimeOut: false,
    countTime: 0,
  };

  componentDidMount() {
    this.calculateMinute();
    this.timer = setInterval(this.calculateMinute, 1000);
  }

  componentWillUnmount() {
    this.clearTimeInterval();
  }

  timer = null;

  clearTimeInterval = () => {
    clearInterval(this.timer);
  };

  calculateMinute = () => {
    const { deliveryTime } = this.props;
    let timeStr = '_ _';
    if (deliveryTime) {
      const countToDate = moment(deliveryTime, COMMON_CONST.FormatDateTime);
      const seconds = moment.duration(countToDate.diff(moment())).asSeconds();
      if (seconds > 0) {
        if (seconds >= 100) {
          timeStr = 99;
        } else {
          timeStr = Math.floor(seconds);
        }
        this.setState({
          countTime: timeStr,
        });
      } else {
        this.setState({
          isTimeOut: true,
        });
        this.clearTimeInterval();
      }
    }
  };

  render() {
    const { isTimeOut, countTime } = this.state;
    return (
      <div>
        {!isTimeOut ? (
          <div
            style={{
              borderRadius: '5px',
              padding: '10px 10px 10px 45px',
              position: 'relative',
              color: '#ffffff',
              fontSize: '12px',
              display: 'inline-block',
            }}
            className={`${EnumOrderMerchantStatus.M_TIMEOUT.class}`}
          >
            <div className="incoming-countdown">
              <div className="circle-rotate">
                <div className="circle" />
              </div>
              <div className="incoming-time">
                {countTime}
              </div>
            </div>
            {trans(EnumOrderMerchantStatus.M_ASSIGNED.description)}
          </div>
        ) : (
          <span
            className={`btn btn-block ${
              EnumOrderMerchantStatus.M_TIMEOUT.class
            }`}
          >
            <i className={EnumOrderMerchantStatus.M_TIMEOUT.icon} />
            {trans(EnumOrderMerchantStatus.M_TIMEOUT.description)}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/components/MAssignedCountDownTime.jsx